module.exports = __webpack_public_path__ + "images/marketing/peeps/mike_galgon.jpg";